import moment from 'moment'

export default (value) => {
  if (value && moment(value).isValid() && moment().diff(value, 'years') < 100) {
    return moment(value).format('DD.MM.YYYY')
  } else {
    return null
  }
}
